<script setup lang="ts">
    interface Props {
        id: string,
        img: string,
        tipo: string,
        campus: string,
        localidad: string,
        address1?: string,
        address2?: string,
        address3?: string,
        address4?: string,
        msj1?: string,
        msj2?: string,
        msj3?: string,
        phone?: string,
        phonec?: string
        phonem?: string
        link?: string,
        button: string,
        lucro?: string,
    }

    defineProps<Props>();
</script>

<template>
    <div :id="id"  class="w-full mt-6 h-full">
        <div class="bg-white border text-left grid gap-4 rounded p-2 transition duration-300 ease-in-out transform hover:shadow-md h-full">
            <img :src="img" :alt="tipo + ' ' + campus">
            <div class="px-2 text-center">
                <h2>
                    <span class="block text-[20px] md:text-[16px] font-normal">{{ tipo }}</span>
                    <span class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span class="block lg:text-[34px] md:text-[26px] font-bold text-[28px] text-hgold font-serif ">{{ campus }}</span>
                </h2>
                <p class="text-hgray">{{ localidad }}</p>
            </div>
            <hr class="border-gray-400">
            <div class="px-2 text-[18px] h-[160px] flex flex-col justify-start">
                <p v-if="address1">{{ address1 }}</p>
                <p v-if="address2">{{ address2 }}</p>
                <p v-if="address3">{{ address3 }}</p>
                <p v-if="address4">{{ address4 }}</p>
                <div v-if="msj3" class="px-2 text-[18px] leading-snug h-[160px] flex flex-col justify-center text-center">
                    <p v-if="msj1" class="">{{ msj1 }}</p>
                    <p v-if="msj2" class="">{{ msj2 }}</p>
                    <p v-if="msj3" v-html="msj3"></p>
                    <p v-if="phonem" class="font-bold phone-container items-center justify-center">
                    Centro de atención México:<br> {{ phonem }}
                    <img src="https://upload.wikimedia.org/wikipedia/commons/f/fc/Flag_of_Mexico.svg" alt="Bandera de México" class="flag-icon">
                    </p>
                    <p v-if="phonec" class="font-bold phone-container items-center justify-center">
                        Centro de atención Bogotá:<br> {{ phonec }}
                    <img src="https://upload.wikimedia.org/wikipedia/commons/2/21/Flag_of_Colombia.svg" alt="Bandera de Colombia" class="flag-icon">
                    </p>
                </div>
                <p v-if="phone" class="font-bold">Tel&eacute;fono: {{ phone }}</p>
                <p v-if="lucro" v-html="lucro" class=""></p>
            </div>
            <div class="flex items-center justify-center">
                <div v-if="link">
                    <a v-if="link && link.includes('http')" :href="link" target="_blank">
                        <button class="rounded-none bg-hgold text-sm transition duration-300 ease-in-out flex items-center justify-center text-white hover:bg-hwine w-[140px] h-[35px] uppercase">{{ button }}</button>
                    </a>
                    <router-link v-else :to="link" rel="noopener noreferrer" target="_blank">
                        <div class="rounded-none bg-hgold text-sm transition duration-300 ease-in-out flex items-center justify-center text-white hover:bg-hwine w-[140px] h-[35px] uppercase">{{ button }}</div>
                    </router-link>
                </div>
                <div v-else class="w-[140px] h-[35px]">
                    <div class="rounded-none bg-trnasparent text-sm ease-in-out flex items-center justify-center  w-[140px] h-[35px] uppercase">{{ button }}</div>
                </div>
            </div>  
        </div>
    </div>
</template>

<style scoped>
    .phone-container {
        display: flex;
        align-items: center;
    }

    .flag-icon {
        width: 20px;
        height: auto;
        margin-left: 10px;
    }
</style>